import React, {FunctionComponent} from 'react';
import cn from 'classnames';

import {UpdateState} from 'enums';
import './StateColor.scss';

interface IStateColorProps {
    className?: string
    state: UpdateState,
}

const stateClasses = {
    [UpdateState.Draft]: 'draft',
    [UpdateState.AwaitApproval]: 'awaitApproval',
    [UpdateState.Scheduled]: 'scheduled',
    [UpdateState.Running]: 'running',
    [UpdateState.Canceled]: 'canceled',
    [UpdateState.Error]: 'error',
    [UpdateState.Done]: 'done',
}

export const StateColor: FunctionComponent<IStateColorProps> = function StateColor(props) {
    const { children, className, state } = props;

    return (
        <span className={cn('stateColor', className, stateClasses[state])}>
            {children}
        </span>
    )
};